import { render, staticRenderFns } from "./DocumentPermissions.vue?vue&type=template&id=4359a246"
import script from "./DocumentPermissions.vue?vue&type=script&lang=js"
export * from "./DocumentPermissions.vue?vue&type=script&lang=js"
import style0 from "./DocumentPermissions.vue?vue&type=style&index=0&id=4359a246&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports